module.exports = {

	config: {
		resourceRegisterKey: 'preview'
	},

	model: {
		routePath: '',
		mailingBaseURL: 'UNDEFINED_BASE_URL',
		mailingID: 0,
		actualViewMode: '',
	},

	events: {
		handleButtonClick: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				var action = $target.data('action');
				var actionTarget = $target.data('target');
				var $iframe = self.$.find('iframe');
				var type = $target.data('type');

				var subscriberID = self.$.find('select[name=adminPreviewSubscriber]').val();
				self.model.actualViewMode = self.$.find('select[name=viewMode]').val();

				// set active class to current button
				self.$.find('button').attr('class', '');
				$target.addClass('active');

				// set iframe size
				if (actionTarget === 'iframe') {
					$iframe.attr('class', type);
				}

				// sending the preview mail must modify params
				if (action === 'sendMailing') {
					self.model.actualViewMode = 'email';
				}

				// call action
				self.performAction(
					self.prepareAction('getMailingPreviewURL', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: {
										attributes: {
											subscriberID:			subscriberID,
											mailingID: 				self.model.mailingID,
											viewMode: 				self.model.actualViewMode,
											generateAndReturnURL: 	true,
											forcePreview:			1
										}
									}
								}
							}
						}
					})
				).then(function(context){
					if (type === 'downloadHtml'){
						window.open(context.response.data.attributes.url + '?fec_force_download=1');
					} else if (actionTarget === 'window') {
						window.open(context.response.data.attributes.url);
					} else {
						$iframe[0].src = context.response.data.attributes.url;
					}
				});
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.mailingBaseURL = (((storage.app || {}).webService || {}).url || '');
			this.model.mailingURL = '';
		},

		getResourceFilters: function(storage, resourceFilters, actionKey) {
			if(actionKey === 'refreshResources'){
				return {
					mailingID: this.model.mailingID
				};
			}

			return resourceFilters;
		},

		sanitizeResources: function(){
			// called with "adminPreviewSubscribers" from resourceRegister
			if (this.resourceData.data) {
				this.model.adminPreviewSubscribers = {
					data: this.resourceData.data
				};
			}
			if (this.resourceData.grantedMailingListIDs) {
				this.model.grantedMailingListIDs = this.resourceData.grantedMailingListIDs;
			}
			// called with "mailingID" from resourceRegister
			if (this.resourceData.mailingID) {
				this.model.mailingID = this.resourceData.mailingID;
			}
			// called with "mailingID" from resourceRegister
			if (this.resourceData.routePath) {
				this.model.routePath = this.resourceData.routePath;
			}
		},

		refreshIframe: function(){
			var $iframe = this.$.find('iframe');
			if($iframe.length > 0 && $iframe[0].src){
				$iframe[0].src = $iframe[0].src;
			}
		}
	},

	hooks: {
		attach: function(){
			this.model.mailingURL = this.model.mailingBaseURL + (this.model.routePath || '');
		}
	},

	handlers: [
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_componentContentForm',
			handle: function(callerComponent){
				if(this.model.actualViewMode !== 'email'){
					this.refreshIframe();
				}
			}
		}
	]
};